export class Third {
    get id() {
        return this.thirdState.id;
    }
    get photo() {
        return this.thirdState.photo;
    }
    get document() {
        return this.thirdState.document;
    }
    get surname1() {
        return this.thirdState.surname1;
    }
    get surname2() {
        return this.thirdState.surname2;
    }
    get genderId() {
        return this.thirdState.genderId;
    }
    get name() {
        return this.thirdState.name;
    }
    get alias() {
        return this.thirdState.alias;
    }
    get email() {
        return this.thirdState.email;
    }
    get phone1() {
        return this.thirdState.phone1;
    }
    get phone2() {
        return this.thirdState.phone2;
    }
    get addressId() {
        return this.thirdState.addressId;
    }
    get addressNotificationId() {
        return this.thirdState.addressNotificationId;
    }
    get birthday() {
        return this.thirdState.birthday;
    }
    get dateOfDeath() {
        return this.thirdState.dateOfDeath;
    }
    get registerUserId() {
        return this.thirdState.registerUserId;
    }
    get creationDate() {
        return this.thirdState.creationDate;
    }
    get updatedDate() {
        return this.thirdState.updatedDate;
    }
    get observations() {
        return this.thirdState.observations;
    }
    get is_lawyer() {
        return this.thirdState.is_lawyer;
    }
    get has_license() {
        return this.thirdState.has_license;
    }
    get collegiate_num() {
        return this.thirdState.collegiate_num;
    }
    set photo(photo) {
        this.thirdState.photo = photo;
    }
    set document(document) {
        this.thirdState.document = document;
    }
    set surname1(surname1) {
        this.thirdState.surname1 = surname1;
    }
    set surname2(surname2) {
        this.thirdState.surname2 = surname2;
    }
    set genderId(genderId) {
        this.thirdState.genderId = genderId;
    }
    set name(name) {
        this.thirdState.name = name;
    }
    set alias(alias) {
        this.thirdState.alias = alias;
    }
    set email(email) {
        this.thirdState.email = email;
    }
    set phone1(phone1) {
        this.thirdState.phone1 = phone1;
    }
    set addressId(addressId) {
        this.thirdState.addressId = addressId;
    }
    set addressNotificationId(addressNotificationId) {
        this.thirdState.addressNotificationId = addressNotificationId;
    }
    set phone2(phone2) {
        this.thirdState.phone2 = phone2;
    }
    set birthday(birthday) {
        this.thirdState.birthday = birthday;
    }
    set dateOfDeath(dateOfDeath) {
        this.thirdState.dateOfDeath = dateOfDeath;
    }
    set registerUserId(registerUserId) {
        this.thirdState.registerUserId = registerUserId;
    }
    set creationDate(creationDate) {
        this.thirdState.creationDate = creationDate;
    }
    set updatedDate(updatedDate) {
        this.thirdState.updatedDate = updatedDate;
    }
    set observations(observations) {
        this.thirdState.observations = observations;
    }
    set is_lawyer(is_lawyer) {
        this.thirdState.is_lawyer = is_lawyer;
    }
    set has_license(has_license) {
        this.thirdState.has_license = has_license;
    }
    set collegiate_num(collegiate_num) {
        this.thirdState.collegiate_num = collegiate_num;
    }
    constructor(thirdState) {
        this.thirdState = thirdState;
    }
    getState() {
        return this.thirdState;
    }
}
